module.exports = __webpack_public_path__ + "static/media/rubrik.291acdc6.png";